import { z } from 'zod';

import locales from 'common/zod/locales';
import { fileUploadSchema, nonEmptyStringSchema } from 'common/zod/schemas';

const MAX_VALUE = 100;
const MAX_VALUE_ERROR_MESSAGE = locales.formatString(
  locales.errors.maxValue,
  MAX_VALUE,
) as string;

const MAX_DECIMALS = 2;
const MAX_DECIMALS_ERROR_MESSAGE = locales.formatString(
  locales.errors.maxDecimals,
  MAX_DECIMALS,
) as string;

const vatItemSchema = z
  .object({
    amount: z
      .number({
        invalid_type_error: locales.errors.required,
        required_error: locales.errors.required,
      })
      .min(0, locales.errors.positive),
    rate: z
      .number({
        invalid_type_error: locales.errors.required,
        required_error: locales.errors.required,
      })
      .min(0, locales.errors.positive)
      .step(0.01, MAX_DECIMALS_ERROR_MESSAGE)
      .max(MAX_VALUE, MAX_VALUE_ERROR_MESSAGE),
  })
  .refine(({ amount, rate }) => {
    // a user should not be able to enter an amount without a rate
    if (amount && (rate === undefined || rate === null)) {
      return false;
    }

    // and vice versa
    if (rate && (amount === undefined || amount === null)) {
      return false;
    }

    return true;
  });

export const receiptUploadFormSchema = z.object({
  amount: z.object({
    total: z
      .number({
        invalid_type_error: locales.errors.required,
        required_error: locales.errors.required,
      })
      .positive({ message: locales.errors.positive }),
    vatItems: z.array(vatItemSchema).min(1),
  }),
  description: nonEmptyStringSchema,
  reseller: nonEmptyStringSchema,
  supportingDocument: fileUploadSchema,
});

export type ReceiptInformationFormSchema = z.infer<
  typeof receiptUploadFormSchema
>;
